import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home, Contact, LandingPage, ProviderSearch, ClaimStatus, ExplanationOfBenefits } from "./components/pages";
import { FooterV2, Navbar } from "./components/shared";
import EligibilityCheck from "./components/pages/eligibilityCheck/EligibilityCheck";
import ScrollToTop from "./utils/commonFunctions/scrollToTop";
import ExplanationIndex from "./components/pages/claimStatus/explanationOfBenefits/ExplanationIndex";

import "./global/globalStyles.css";
import BreakingNewsAlert from "./components/pages/home/breakingAlert/BreakingAlert";
import PrivacyPolicy from "./components/pages/privacyPolicy/PrivacyPolicy";

const App = () => {
	return (
		<div className="App">
			<BrowserRouter>
				<ScrollToTop />
				<Navbar />
				<BreakingNewsAlert />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/landing-page" element={<LandingPage />} />
					<Route path="privacy-policy" element={<PrivacyPolicy />} />
					<Route path="/provider-search" element={<ProviderSearch />} />
					<Route path="/eligibility-check" element={<EligibilityCheck />} />
					<Route path="/claim-status" element={<ClaimStatus />} />
					<Route path="/claim-status/EOB" element={<ExplanationIndex />} />
				</Routes>
				<FooterV2 />
			</BrowserRouter>
		</div>
		//yo
	);
};

export default App;
